<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="标题：">
        <el-input v-model="query.title" placeholder="请输入标题" clearable size="small" />
      </el-form-item>
      <el-form-item label="分享人手机号：">
        <el-input v-model="query.userPho" placeholder="请输入手机号" clearable size="small" />
      </el-form-item>
      <el-form-item label="操作时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import sysGoodsApi from '@/api/goods/sysGoods'
import { filterEmpty } from '@/utils'
import templateMaterialsShareAnalyzeApi from "@/api/marketing/templateMaterialsShareAnalyze";
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        title: undefined,
        userPho: undefined
      }
    }
  },
  created() {
    // 从路由参数中获取查询条件
    const { title, userPho } = this.$route.query;
    if (title) {
      this.query.title = title;
    }
    if (userPho) {
      this.query.userPho = userPho;
    }
  },
  methods: {
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      let params = JSON.parse(JSON.stringify(this.query))
      
      return this.$common.confirm('是否确认导出')
        .then(() => templateMaterialsShareAnalyzeApi.MaterialsShareExport(filterEmpty(params))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    }
  }
}
</script>

<style>
</style>
